import { useState, useEffect, useCallback } from 'react';
import { loadApiKey, saveApiKey as saveApiKeyToStorage } from '../utils/storage.js';

export const useApiKey = () => {
  const [apiKey, setApiKey] = useState('');
  const [tempApiKey, setTempApiKey] = useState('');
  const [showApiKeyModal, setShowApiKeyModal] = useState(false);
  const [apiError, setApiError] = useState(null);

  // LocalStorageからAPIキーを読み込み
  useEffect(() => {
    const savedApiKey = loadApiKey();
    if (savedApiKey) {
      setApiKey(savedApiKey);
    } else {
      // APIキーが設定されていない場合はモーダルを表示
      setTempApiKey('');
      setShowApiKeyModal(true);
    }
  }, []);

  // APIキーを保存
  const saveApiKey = useCallback(() => {
    if (tempApiKey.trim()) {
      setApiKey(tempApiKey);
      saveApiKeyToStorage(tempApiKey);
      setShowApiKeyModal(false);
      setApiError(null);
    }
  }, [tempApiKey]);

  // APIキーモーダルを開く
  const openApiKeyModal = useCallback(() => {
    setTempApiKey(apiKey || '');
    setShowApiKeyModal(true);
  }, [apiKey]);

  return {
    apiKey,
    tempApiKey,
    setTempApiKey,
    showApiKeyModal,
    setShowApiKeyModal,
    apiError,
    setApiError,
    saveApiKey,
    openApiKeyModal
  };
};